import { createSelector } from "reselect";

import EntityType from "@mapmycustomers/shared/enum/EntityType";

import { RootState } from "@app/store/rootReducer";
import getDealLock, { LockableDeal } from "@app/util/deal/getDealLock";

const dealState = (state: RootState) => state.deal;

export const getFunnels = createSelector(dealState, ({ funnels }) => funnels);
export const getFunnelStages = createSelector(dealState, ({ funnelStages }) => funnelStages);
export const getDealRefs = createSelector(dealState, ({ dealRefs }) => dealRefs);

export const isCreatingFunnel = createSelector(
  dealState,
  ({ createFunnelLoading }) => createFunnelLoading
);
export const isUpdatingFunnel = createSelector(
  dealState,
  ({ updateFunnelLoading }) => updateFunnelLoading
);
export const isDeletingFunnel = createSelector(
  dealState,
  ({ deleteFunnelLoading }) => deleteFunnelLoading
);

export const isCreatingStage = createSelector(
  dealState,
  ({ createStageLoading }) => createStageLoading
);
export const isUpdatingStage = createSelector(
  dealState,
  ({ updateStageLoading }) => updateStageLoading
);
export const isDeletingStage = createSelector(
  dealState,
  ({ deleteStageLoading }) => deleteStageLoading
);

export const isUpdatingDeal = createSelector(
  dealState,
  ({ updateDealLoading }) => updateDealLoading
);

export const getDealLockGetter = createSelector(
  getFunnels,
  getFunnelStages,
  (funnels, funnelStages) => (deal: LockableDeal) => getDealLock(deal, funnels, funnelStages)
);

// For surfaces that show any record kind (frequency panel and modal): only a deal can be locked
export const getReadOnlyDealChecker = createSelector(
  getDealLockGetter,
  (getDealLock) =>
    (record: { entity?: EntityType } & Partial<LockableDeal>): boolean =>
      record.entity === EntityType.DEAL && !getDealLock(record as LockableDeal).canEdit
);

// The bulk delete check, for selections that can hold any record kind: a deal's funnel or stage lock
export const getDeleteLockedDealChecker = createSelector(
  getDealLockGetter,
  (getDealLock) =>
    (record: { entity?: EntityType } & Partial<LockableDeal>): boolean =>
      record.entity === EntityType.DEAL && !getDealLock(record as LockableDeal).canDelete
);
